import { FC } from "react"
import Skeleton from "../base"

interface Props {
  tabCount?: number
  fieldCount?: number
}

const ConfigEditPageSkeleton: FC<Props> = ({
  tabCount = 3,
  fieldCount = 5
}) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header zone */}
      <Skeleton className="bg-white px-6 py-4">
        {/* Back link */}
        <div className="h-4 w-28 rounded bg-gray-200 mb-3" />

        {/* Title row */}
        <div className="flex flex-col md:flex-row gap-3">
          <div className="flex items-center gap-3">
            <div className="h-7 w-52 rounded bg-gray-200" />
            <div className="h-3.5 w-3.5 rounded bg-gray-200" />
          </div>

          {/* Right-side actions */}
          <div className="md:ml-auto flex items-center gap-3">
            {/* Switch ghost */}
            <div className="flex items-center gap-2">
              <div className="h-5 w-8 rounded-full bg-gray-200" />
              <div className="h-4 w-12 rounded bg-gray-200" />
            </div>

            <div className="w-px h-5 bg-gray-200" />

            {/* Delete ghost */}
            <div className="h-5 w-14 rounded bg-gray-200" />

            {/* Cancel ghost */}
            <div className="h-9 w-20 rounded-lg bg-gray-200" />

            {/* Save ghost */}
            <div className="h-9 w-28 rounded-lg bg-gray-200" />
          </div>
        </div>

        {/* Brand autocomplete ghost */}
        <div className="mt-4 max-w-xs h-9 rounded-lg bg-gray-200" />
      </Skeleton>

      {/* Tabs zone */}
      <Skeleton className="bg-white px-6 border-b border-gray-100">
        <div className="flex gap-1 pt-1 pb-0">
          {Array.from({ length: tabCount }).map((_, i) => (
            <div
              key={i}
              className="h-9 rounded-t-md bg-gray-200"
              style={{ width: `${60 + (i % 2) * 16}px` }}
            />
          ))}
        </div>
      </Skeleton>

      {/* Form content zone */}
      <Skeleton className="bg-white">
        <div className="max-w-2xl py-6 px-6 space-y-6">
          {Array.from({ length: fieldCount }).map((_, i) => (
            <div key={i} className="space-y-1.5">
              <div className="h-3.5 w-24 rounded bg-gray-200" />
              <div
                className="h-9 rounded-lg bg-gray-200"
                style={{ width: i % 3 === 2 ? "60%" : "100%" }}
              />
            </div>
          ))}
        </div>
      </Skeleton>
    </div>
  )
}

export default ConfigEditPageSkeleton
